import {useContext} from 'react'

import {LocatorContext} from '../../../../contexts/locator'
import type {State} from '../../../../reducers/types'
import {getBuildsHasError} from '../../../../selectors'
import {useSequenceLoaderReadyHandler} from '../../SequenceLoader/SequenceLoader.hooks'
import Pager from '../Pager.container'
import {PagerGroup} from '../Pager.types'

import BuildPagerWarning from './BuildPagerWarning.container'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  seqKey?: string
}

const getIsLoading = (state: State) => state.pager[PagerGroup.BUILD].isLoading

export default function BuildPager(props: Props) {
  const locator = useContext(LocatorContext) ?? ''
  const isLoading = useAppSelector(getIsLoading)
  useSequenceLoaderReadyHandler(!isLoading)
  return (
    <Pager
      {...props}
      isLoading={isLoading}
      hasError={useAppSelector(state => getBuildsHasError(state, locator))}
      warningComponent={BuildPagerWarning}
      group={PagerGroup.BUILD}
    />
  )
}
